/**
 * firebase.js
 * Centralizes Firebase configuration and initialization
 * Provides Firebase services and analytics tracking
 */

import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getAnalytics, logEvent } from 'firebase/analytics';

// Firebase configuration object
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_MEASUREMENT_ID
};

// const firebaseConfig = {
//   apiKey: 'AIzaSyAyRH_xpxTzGMvjP1_ISQUPaDXfdJMxxaw',
//   authDomain: 'surveyslack2024.firebaseapp.com',
//   projectId: 'surveyslack2024',
//   storageBucket: 'surveyslack2024.appspot.com',
//   messagingSenderId: '656023429979',
//   appId: '1:656023429979:web:435635fd0a220d0a94707e',
//   measurementId: 'G-6M6CPWVXQW',
// };


// Initialize Firebase services
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const analytics = getAnalytics(app);
export const googleProvider = new GoogleAuthProvider();

/**
 * Helper function to track analytics events
 * Provides a standardized interface for event tracking
 * @param {string} eventName - Name of the event to track
 * @param {Object} eventParams - Additional parameters for the event
 */
export const trackEvent = (eventName, eventParams = {}) => {
  logEvent(analytics, eventName, eventParams);
};
